import script from "./ApplicationMaterialsTab.vue?vue&type=script&setup=true&name=ApplicationMaterialsTab&lang=js"
export * from "./ApplicationMaterialsTab.vue?vue&type=script&setup=true&name=ApplicationMaterialsTab&lang=js"

import "./ApplicationMaterialsTab.vue?vue&type=style&index=0&id=020e5f40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020e5f40"]])

export default __exports__